export default __webpack_public_path__ + "static/media/62t.69091bc9.jpg";